
export const SKIP_MODAL_WINDOW_INTERCEPTOR_HEADER = 'X-Skip-Modal-Window-Interceptor';
